export const getViewport = state => state.globals.viewport;



// WEBPACK FOOTER //
// ./src/redux/globals/selectors.js